var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 167,
    viewBox: "0 0 230 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.123 62.5864C114.123 62.5864 132.597 50.8647 140.763 41.7727C148.929 32.6807 161.879 9.41354 161.879 9.41354",
    stroke: "#00A617",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.646 101.462C226.646 101.462 205.215 97.0613 193.025 97.9291C180.835 98.7969 155.357 106.538 155.357 106.538",
    stroke: "#00A617",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M153.71 71.6826C153.71 71.6826 156.018 69.3101 157.242 68.982C157.453 68.9254 157.729 68.9132 158.04 68.9316C160.476 69.0757 162.973 68.8134 165.031 67.5045C165.962 66.9127 166.939 66.3837 167.722 66.174C168.639 65.9283 170.023 65.9245 171.318 66.0026C173.469 66.1322 175.601 65.471 177.314 64.1632C177.955 63.6733 178.563 63.2692 178.927 63.1716C179.993 62.8858 183.654 63.6592 183.654 63.6592",
    stroke: "#00A617",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.306 137.628C142.306 137.628 145.904 136.719 147.339 137.05C147.808 137.159 148.436 137.523 149.069 137.965C150.823 139.19 152.924 139.896 155.058 139.749C156.639 139.64 158.431 139.611 159.615 139.885C160.925 140.187 162.77 141.154 164.255 142.023C165.878 142.974 167.782 143.352 169.645 143.087C170.883 142.91 172.173 142.784 172.741 142.915C173.99 143.203 177.384 145.726 177.384 145.726",
    stroke: "#00A617",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9156 46.5689C92.9156 46.5689 95.2292 45.1664 95.5509 44.2826V44.2826C96.3156 42.1816 96.051 39.7593 97.474 38.0348C97.8492 37.5801 98.1566 37.1236 98.304 36.7186C98.4221 36.3941 98.4838 35.9754 98.5074 35.5153C98.6371 32.9829 100.38 31.0136 101.248 28.6309V28.6309C101.528 27.8611 100.782 24.956 100.782 24.956",
    stroke: "#00A617",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185.002,
    cy: 127,
    r: 4,
    stroke: "#00A617",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.002,
    cy: 67,
    r: 4,
    fill: "#00A617"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.002,
    cy: 115,
    r: 4,
    fill: "#E00B7E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.002,
    cy: 60,
    r: 4,
    stroke: "#00A617",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.002,
    cy: 16,
    r: 5,
    stroke: "#E00B7E",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 134.502,
    cy: 100.5,
    r: 4.5,
    stroke: "#00A617",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.248 50.5369L106.888 49.8834C106.005 49.751 105.725 48.6151 106.446 48.0875L109.786 45.6433L110.233 41.5291C110.329 40.6411 111.453 40.3155 112.009 41.0143L114.755 44.4628L119.114 45.1164C119.997 45.2488 120.277 46.3847 119.556 46.9123L116.217 49.3565L115.77 53.4707C115.673 54.3586 114.55 54.6843 113.993 53.9855L111.248 50.5369Z",
    fill: "#00A617"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.248 31.5369L188.888 30.8834C188.005 30.751 187.725 29.6151 188.446 29.0875L191.786 26.6433L192.233 22.5291C192.329 21.6411 193.453 21.3155 194.009 22.0143L196.755 25.4628L201.114 26.1164C201.997 26.2488 202.277 27.3847 201.556 27.9123L198.217 30.3565L197.77 34.4707C197.673 35.3586 196.55 35.6843 195.993 34.9855L193.248 31.5369Z",
    fill: "#00A617"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.248 87.5369L166.888 86.8834C166.005 86.751 165.725 85.6151 166.446 85.0875L169.786 82.6433L170.233 78.5291C170.329 77.6411 171.453 77.3155 172.009 78.0143L174.755 81.4628L179.114 82.1164C179.997 82.2488 180.277 83.3847 179.556 83.9123L176.217 86.3565L175.77 90.4707C175.673 91.3586 174.55 91.6843 173.993 90.9855L171.248 87.5369Z",
    fill: "#E00B7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.357 121.237L143.421 119.671C142.726 119.109 143.061 117.987 143.95 117.898L146.16 117.677L147.457 115.874C147.978 115.148 149.117 115.419 149.257 116.302L149.645 118.762L151.582 120.329C152.276 120.891 151.941 122.012 151.052 122.101L148.842 122.322L147.545 124.126C147.024 124.851 145.885 124.581 145.746 123.698L145.357 121.237Z",
    fill: "#00A617"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.357 42.2375L157.421 40.671C156.726 40.109 157.061 38.9874 157.95 38.8984L160.16 38.6773L161.457 36.8738C161.978 36.1482 163.117 36.4189 163.257 37.3016L163.645 39.762L165.582 41.3286C166.276 41.8905 165.941 43.0121 165.052 43.1011L162.842 43.3222L161.545 45.1258C161.024 45.8513 159.885 45.5806 159.746 44.698L159.357 42.2375Z",
    fill: "#00A617"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.357 82.2375L113.421 80.671C112.726 80.109 113.061 78.9874 113.95 78.8984L116.16 78.6773L117.457 76.8738C117.978 76.1482 119.117 76.4189 119.257 77.3016L119.645 79.762L121.582 81.3286C122.276 81.8905 121.941 83.0121 121.052 83.1011L118.842 83.3222L117.545 85.1258C117.024 85.8513 115.885 85.5806 115.746 84.698L115.357 82.2375Z",
    fill: "#E00B7E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4949 74.795C84.0523 71.6052 88.9813 71.8515 91.2081 75.2804L124.979 127.283C127.235 130.757 125.375 135.418 121.348 136.385L27.8933 158.822C22.3332 160.157 18.2345 153.696 21.8114 149.235L81.4949 74.795Z",
    fill: "white",
    stroke: "#00A617",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3262 149.301L121.001 121.354C121.001 121.354 123.212 125.902 125.045 131C126.879 136.097 125.045 135.976 125.045 135.976L24.001 158L21.3262 149.301Z",
    fill: "#00A617"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.668 86.2783L106.668 139.278",
    stroke: "#00A617",
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.668 98.2783L88.533 144.43",
    stroke: "#00A617",
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.668 114.278L70.8137 149.301",
    stroke: "#00A617",
    strokeLinecap: "square"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.668 127.278L53.1282 152.884",
    stroke: "#00A617",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.0ce19bb8139665c79caf01b623d59973.svg";
export { ForwardRef as ReactComponent };